import { render, staticRenderFns } from "./CameraView.vue?vue&type=template&id=10031a5c"
import script from "./CameraView.vue?vue&type=script&lang=js"
export * from "./CameraView.vue?vue&type=script&lang=js"
import style0 from "./CameraView.vue?vue&type=style&index=0&id=10031a5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports